import React from "react";
import { Outlet } from "react-router-dom";

const Chat = () => {
  return <Outlet />;
};

export default Chat;
